export default {
  CUPOM_OFFERS_FETCHED: 'CUPOM_OFFERS_FETCHED',
  CUPOM_OFFERS_LOAD: 'CUPOM_OFFERS_LOAD',
  CUPOM_OFFERS_DETAIL: 'CUPOM_OFFERS_DETAIL',
  STATIONS_LOAD: 'STATIONS_LOAD',
  STATIONS_FETCHED: 'STATIONS_FETCHED',
};
